const Footer = () => {
  return (
    <>
      <section className="container-fluid bg-dark text-white" id="footer">
        <section className="container">
          <section className="row" id="box5 mt-5 pt-5 pb-5 ">
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>WoxFit</h1>
              <p className="set2">
                Parturient porttitor quam mattis ipsum imperdiet habitasse orci.
                Risus integer.
              </p>
              <div className="icons">
              <i class="fab fs-3 me-4 fa-instagram"></i>
              <i class="fab fs-3 me-4 fa-twitter"></i>
              <i class="fab fs-3 me-4 fa-facebook"></i>

              </div>
            </div>
            <div className=" col-12 col-md-6 col-xl-3 mt-5 ">
              <h1>About</h1>
              <p className="set5">About us</p>
              <p className="set5">Blog</p>
              <p className="set5">Careers</p>
              <p className="set5">Jobs</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Services</h1>
              <p className="box10">How we work</p>
              <p className="box10">Portfolio</p>
              <p className="box10">Pricing</p>
              <p className="box10">More</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Support</h1>
              <p>Contact us</p>
              <p>online chat</p>
              <p>Whatsapp</p>
              <p>Telegram</p>
              
            </div>
            {/* <div className="col-12 col-md-6 col-xl-3 mt-5">
                
            </div> */}

            <p className="text-center py-5">
              © 2021 Qode Interactive, All Rights Reserved
            </p>
          </section>
        </section>
      </section>
    </>
  );
};
export default Footer;
